import { render, staticRenderFns } from "./DegreesList.vue?vue&type=template&id=85e00336&"
import script from "./DegreesList.vue?vue&type=script&lang=js&"
export * from "./DegreesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports